import BetBarComponent, { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import ButtonElement from "slotworks/graphics/elements/button-element";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import Currency from "slotworks/i18n/currency";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";
import { HitArea } from "slotworks/utils/geom/hit-area";
import GoldenRockSpinButtonRingComponent from "./golden-rock-spin-button-ring-component";

export default class GoldenRockBetBarComponent extends BetBarComponent {

    public static MENU: BetBarType = new BetBarType("menu");
    public static TOTAL_STAKE_MENU: BetBarType = new BetBarType("total_stake_panel");
    public static BET_BAR_TYPES: BetBarType[] = [
        GoldenRockBetBarComponent.MENU,
        GoldenRockBetBarComponent.TOTAL_STAKE_MENU
    ];
    public static SPIN_BTN_HIT_AREAS: Map<string, HitArea> = new Map<string, HitArea>([
        ["spin_button", new PIXI.Circle(70.6, 73.8, 64.8)],
        ["spin_button_skip", new PIXI.Circle(70.6, 73.8, 64.8)],
        ["ukgc_autoplay_start_button", new PIXI.Circle(70.6, 73.8, 64.8)],
        ["spin_to_start_button", new PIXI.Circle(70.6, 73.8, 64.8)],
        ["hold_spin_button_skip", new PIXI.Circle(70.6, 73.8, 64.8)],
        ["hold_spin_button", new PIXI.Circle(70.6, 73.8, 64.8)]
    ] as any);

    private static LAST_WINNINGS: string = "last_win_value";
    private lastWinnings: FlexiText;
    private lastWinningsValue: number;

    constructor() {
        super();

        for (const betBarType of GoldenRockBetBarComponent.BET_BAR_TYPES) {
            if (Layers.BetBar.hasScene(betBarType.toString())) {
                const group = SmartUIManager.newSmartUIGroup(
                    Layers.BetBar,
                    betBarType.toString(),
                    "betbar_" + betBarType.toString()
                );
                group.addDisableCondition([SmartUIFlag.FREE_SPINS]);
                group.addDisableCondition([SmartUIFlag.AUTO_SPIN_SELECT]);
            }
        }

        this.setLastWinnings(0);

        this.setupSpinButtonHitAreas();
        Layers.SmartButton.onSceneEnter.add(this.setupSpinButtonHitAreas, this);
    }

    public setLastWinnings(value: number): void {
        this.lastWinningsValue = value;

        if (this.lastWinnings) {
            if (value > 0) {
                this.lastWinnings.setText(Currency.format(this.lastWinningsValue));
            } else {
                this.lastWinnings.setText("");
            }
        }
    }

    public setTotalFreespins(value: number) {
        super.setTotalFreespins(value);

        GoldenRockSpinButtonRingComponent.setTotalSpins(value);
    }

    public setFreespinsPlayed(value: number) {
        super.setFreespinsPlayed(value);

        GoldenRockSpinButtonRingComponent.setTotalPlayed(value);
    }

    protected refresh(): void {
        super.refresh();

        this.lastWinnings = Layers.BetBar.getFlexiText(GoldenRockBetBarComponent.LAST_WINNINGS);

        this.setLastWinnings(this.lastWinningsValue);
    }

    protected setupTexts(): void {
        super.setupTexts();

        if (!this.freespinsRemainingText) {
            this.freespinsRemainingText = Layers.SmartButton.getFlexiText(BetBarComponent.FREESPINS_REMAINING_VALUE);
        }

        this.repositionFreespinText();
        this.repositionAutoplayText();
    }

    protected updateTexts(): void {
        this.setupTexts();

        super.updateTexts();
    }

    protected setupSpinButtonHitAreas(): void {
        Array.from(GoldenRockBetBarComponent.SPIN_BTN_HIT_AREAS.keys()).forEach((buttonName: string) => {
            const button: ButtonElement = Layers.SmartButton.getButton(buttonName);
            if (button) {
                if (GoldenRockBetBarComponent.SPIN_BTN_HIT_AREAS.has(buttonName)) {
                    const hitArea = GoldenRockBetBarComponent.SPIN_BTN_HIT_AREAS.get(buttonName);
                    button.setHitArea(hitArea);
                }
            }
        });
    }

    private repositionFreespinText(): void {
        const freespinsText = Layers.SmartButton.getText("freespins_text");
        const freespinsRemainingText = Layers.SmartButton.getText("freespins_remaining_value");

        if (freespinsText) {
            freespinsText.parent.addChildAt(freespinsText, 2);
        }
        if (freespinsRemainingText) {
            freespinsRemainingText.parent.addChildAt(freespinsRemainingText, 2);
        }
    }

    private repositionAutoplayText(): void {
        const autoplayText = Layers.SmartButton.getText("autoplays_text");
        const autoplayCountText = Layers.SmartButton.getText("autoplays_count");

        if (autoplayText) {
            autoplayText.parent.addChildAt(autoplayText, 1);
        }
        if (autoplayCountText) {
            autoplayCountText.parent.addChildAt(autoplayCountText, 1);
        }
    }
}
